import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import typeahead from 'typeahead.js';
import Bloodhound from 'bloodhound-js';
import setAttributes from './utility/set-attributes';

const mainForm = document.querySelector('#main-form');

const selectedSuggestionList = document.querySelector('#selected-suggestion-list');
const bookSeriesClearSelection = document.querySelector('#book-series-clear-selection');
const bookSeriesTextarea = document.querySelector('#book-series-collection');
let preselectedItemsArray = [];

// inserted with js for PE.
let bookSeriesCollector;

class BookSeries {
	constructor(restApi, recordsCount) {
		this.restApi = restApi;
		this.recordsCount = recordsCount;
		this.dynamicListCollection = [];
		this.checkIfJs();
		this._collectTextareaVal();
		this._initBookSeriesSearch(bookSeriesCollector);
		this._onBookSeriesSuggestionSelect(bookSeriesCollector);
		this._onBookSeriesDeleteAllClick();
		this._onDeleteItemBookSeriesSelection();
		this._initBloodhound();
		this._displayInElement(bookSeriesTextarea, preselectedItemsArray);
	}

	_initBloodhound() {
		const bookSeries = new Bloodhound({
			datumTokenizer: datum => {
				return Bloodhound.tokenizers.whitespace(datum.title);
			},
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: `/metadata/books/series?query={query}`,
				wildcard: '{query}'
			}
		});
		bookSeries.initialize();
		return bookSeries;
	}

	_onBookSeriesSuggestionSelect(bookSeriesCollector) {
		$(bookSeriesCollector).on('typeahead:select', (event, suggestion) => {
			$(bookSeriesCollector).typeahead('val', '');
			this.dynamicListCollection = this._collectTextareaVal();
			this._deleteListValues();

			const value = suggestion.title;
			this.dynamicListCollection.push(value);
			const valuesUniq = [...new Set(this.dynamicListCollection.map(a => a))];
			this.dynamicListCollection = valuesUniq;
			this._displaySelectedSeriesCollection(this.dynamicListCollection);
			this._callWithTimeout();
		});
	}

	_onDeleteItemBookSeriesSelection() {
		$(selectedSuggestionList).on('click', event => {
			const targetSuggestionItem = event.target.textContent;
			if (event.target.classList.contains('c-book-series__selected-suggestion-list-item')) {
				for (let index = 0; index < this.dynamicListCollection.length; index++) {
					if (this.dynamicListCollection[index] === targetSuggestionItem) {
						this.dynamicListCollection.splice(index, 1);
						break;
					}
				}

				// preselectedItemsArray is important for sharable link
				preselectedItemsArray = this.dynamicListCollection;

				event.target.remove();
				bookSeriesTextarea.value = '';
				const textareaArray = [];
				for (const item of this.dynamicListCollection) {
					textareaArray.push(item);
				}
				bookSeriesTextarea.value = textareaArray.join('\n');
			}
			this._callWithTimeout();
		});
	}

	_onBookSeriesDeleteAllClick() {
		$(bookSeriesClearSelection).on('click', event => {
			event.preventDefault();
			this._deleteAllBookSeriesSelection();
			this._callWithTimeout();
		});
	}

	_callWithTimeout() {
		// IE trick for have records count working (no better solution atm)
		setTimeout(() => {
			this._dispatchMainFormChangeEvent();
		}, 300);
	}

	_dispatchMainFormChangeEvent() {
		// update records count
		mainForm.dispatchEvent(new CustomEvent('change'));
	}

	_initBookSeriesSearch(bookSeriesCollector) {
		$(bookSeriesCollector).typeahead({
			hint: false,
			highlight: true,
			minLength: 2,
			classNames: {
				input: 'p-typeahead__suggestion__input',
				selectable: 'p-typeahead__suggestion__item',
				menu: 'p-typeahead__suggestion__menu',
				cursor: 'p-typeahead__suggestion__cursor'
			}
		},
		{
			name: 'title',
			display: 'title',
			source: this._initBloodhound().ttAdapter(),
			templates: {
				empty: '<p class="p-typeahead__empty">No matches found.</p>',
				suggestion: item => {
					return `<p>${item.title}</p>`;
				}
			}
		});
	}

	_deleteListValues() {
		if (selectedSuggestionList) {
			if (selectedSuggestionList.hasChildNodes()) {
				selectedSuggestionList.innerHTML = '';
			}
			bookSeriesTextarea.value = '';
		}
	}

	_deleteAllBookSeriesSelection() {
		this.dynamicListCollection.length = 0;
		preselectedItemsArray.length = 0;
		this._deleteListValues();
	}

	_displaySelectedSeriesCollection(array) {
		const uniqueArray = [];

		for (const element of array) {
			// display items in the interactive list
			const nodeLi = document.createElement('li');
			const nodeLiTextNode = document.createTextNode(element);
			nodeLi.classList.add('c-book-series__selected-suggestion-list-item');
			nodeLi.appendChild(nodeLiTextNode);
			selectedSuggestionList.appendChild(nodeLi);
			// display items in the js hidden textarea
			uniqueArray.push(element);
		}
		this._displayInElement(bookSeriesTextarea, uniqueArray);
	}

	_collectTextareaVal() {
		const listItems = document.querySelectorAll('.c-book-series__selected-suggestion-list-item');

		if (listItems.length > 0) {
			for (const listItem of listItems) {
				preselectedItemsArray.push(listItem.innerHTML);
			}
		}

		this._displayInElement(bookSeriesTextarea, preselectedItemsArray);
		return preselectedItemsArray;
	}

	_displayInElement(element, array) {
		if (element) {
			element.value = array.join('\n');
		}
	}

	_setAttributes(element, attributes) {
		for (const key in attributes) {
			if (attributes && element) {
				element.setAttribute(key, attributes[key]);
			}
		}
	}

	_addInputToBookSeriesCollector() {
		if (document.querySelector('#book-series-collector')) {
			const collector = document.querySelector('#book-series-collector');
			const input = document.createElement('input');
			setAttributes(input, {
				id: 'book-series-collector-input',
				type: 'text',
				class: 'c-input',
				placeholder: 'Enter the series title to add to the selection',
				value: ''
			});
			collector.appendChild(input);
		}
	}

	checkIfJs() {
		if (document.body.classList.contains('js')) {
			this._addInputToBookSeriesCollector();
			bookSeriesCollector = document.querySelector('#book-series-collector-input');
		}
	}
}

export default BookSeries;
